export const GET_ROL = `
  query {
    getRolAdmin {
      message
      rol {
        id
        name
      }
    }
  }
`;

export const GET_LIST_USER_ROLE = `
  query {
    getUserRol {
        message
        succes
        user {
            id
            email
            status
            roles {
                name
            }
            permissions {
                name
            }
        }
    }
  }
`;

export const GET_PERMISSION_USER = `
  query($id_users: String!) { 
    getPermission(id_users: $id_users) { 
      message 
      status 
      permissions { 
        id 
        name 
      }
      permissions1 { 
        id 
        name 
      }  
    } 
  }
`;